import axios from "axios";
//http client
import configData from "./../configData";
import { tokenConfig } from "./authActions";
import {
  ITEM_NOTIFICATION,
  DISPLAY_FREE,
  GET_FREE,
  CONNECT_FREE,
} from "./types";

export const displayCreateFree = (info) => (dispatch, getState) => {
  dispatch({
    type: DISPLAY_FREE,
    payload: info,
  });
};

// export const connectFree = (info) => (dispatch, getState) => {
//   dispatch({
//     type: CONNECT_FREE,
//     payload: info,
//   });
// };

export const createFree = (info) => (dispatch, getState) => {
  dispatch({
    type: ITEM_NOTIFICATION,
    payload: "Free loading...",
  });
  axios
    .post(`${configData.SERVER_URL}free`, info, {
      headers: {
        "Content-type": "application/json",
      },
    })
    .then((res) => {
      dispatch({
        type: GET_FREE,
        payload: res.data,
      });
      const urlObj = new URL(res.data.freeUrl);
      const token = urlObj.searchParams.get("token");

      dispatch({
        type: CONNECT_FREE,
        payload: { token },
      });
      setTimeout(async () => {
        //   try {
        //     await navigator.clipboard.writeText(res.data.freeUrl);
        //   } catch {
        //     console.log("dont worry");
        //   }
        window.location.href = res.data.freeUrl;
      }, 5000);
    })
    .catch((error) => {
      if (error.response) {
        // Request made and server responded
        console.log(error.response.data);
        console.log(error.response.status);
        console.log(error.response.headers);
        if (error.response.data)
          if (error.response.data.res)
            if (
              error.response.data.res.includes("err token or user undefined")
            ) {
              console.log("error", error.response);
              // dispatch({
              //   type: LOGOUT_SUCCESS,
              // });
            }
      } else if (error.request) {
        // The request was made but no response was received

        console.log(error.request);
      } else {
        // Something happened in setting up the request that triggered an Error
        console.log("Error", error.message);
      }
    });
};
